import {Context, ROOT_CONTEXT, ContextManager} from '@opentelemetry/api';
import {NavigationInstruction} from 'aurelia-router';

export class AureliaRouteContextManager implements ContextManager {
    private static instanceCount: number = 0;
    private static instanceAccessLog: () => void = () => {
        console.log(`AureliaRouteContextManager instances: ${AureliaRouteContextManager.instanceCount}`);
    };
    private readonly instanceId: number;
    private _contextsByRoute: Map<string, Context> = new Map();
    private _currentContext: Context = ROOT_CONTEXT;

    constructor() {

        AureliaRouteContextManager.instanceCount++;
        this.instanceId = Date.now();
        AureliaRouteContextManager.instanceAccessLog();
    }

    enable(): this {
        return this;
    }

    disable(): this {

        return this;
    }

    active(): Context {
        return this._currentContext;
    }

    with<A extends unknown[], F extends (...args: A) => ReturnType<F>>(
        context: Context,
        fn: F,
        thisArg?: ThisParameterType<F>,
        ...args: A
    ): ReturnType<F> {
        var symbol = Symbol('OpenTelemetry SDK Context Key SUPPRESS_TRACING');

        // add this to eaiser debuggin count = 2 is during supress when exporter sends to server
        // @ts-ignore
        if (context._currentContext.toArray().length === 1) {
            var test = "test";
        }
        this._currentContext = context;

        return fn.call(thisArg, ...args);

    }

    bind<T>(context: Context, target: T): T {
        if (typeof target === 'function') {
            return ((...args: any[]) => {
                const oldContext = this._currentContext;
                this._currentContext = context;
                console.log(`[AureliaRouteContextManager] Binding context to function`, context);
                try {
                    return (target as (...args: any[]) => any)(...args);
                } finally {
                    this._currentContext = oldContext;
                    console.log(`[AureliaRouteContextManager] Restoring context after function call: back to ${oldContext}`, oldContext);
                }
            }) as unknown as T;
        } else {
            console.error('[AureliaRouteContextManager] bind target must be a function');
            return target;
        }
    }


    public UpdateContext(event: { instruction: NavigationInstruction }): void {
        const route = event.instruction.fragment;
        const newContext = this._contextsByRoute.get(route) || ROOT_CONTEXT;
        // Debugging: Log context change on route change
        console.log(`Route change detected: ${route}, Changing context from: ${this._currentContext} to new context: ${newContext}`, newContext);
        this._currentContext = newContext;
    }

    public ClearContext(): void {
        const newContext = ROOT_CONTEXT;
        // Debugging: Log context change on route change
        this._currentContext = newContext;
    }
}